import { render } from "./ModalConfirm.vue?vue&type=template&id=0477b97c&ts=true"
import script from "./ModalConfirm.vue?vue&type=script&lang=ts"
export * from "./ModalConfirm.vue?vue&type=script&lang=ts"

import "./ModalConfirm.vue?vue&type=style&index=0&id=0477b97c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__